import React, { PureComponent } from 'react';
import KuposSuccessFailure from './KuposSuccessFailure';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

class PageNotFound extends PureComponent {
  render() {
    return (
      <div className="common-page-not-found page-not-found">
        <KuposSuccessFailure
          // success={true}
          title={i18next.language == 'es' ? 'Ooops!' : 'Ooops!'}
          icon={'/static/images/404-icon.png'}
          subtitle={
            i18next.language == 'es'
              ? 'La página que buscas no existe... o ha desaparecido'
              : "The page you're looking for doesn't exist... or it has gone missing!"
          }
          infoText={
            i18next.language == 'es'
              ? '¡Intenta explorando otras secciones!'
              : 'Please try exploring other sections!'
          }
          t={this.props.t}
        >
          <div className="successful-purchase-buttons font12">
            <button className="kupos-button active" onClick={() => this.props.history.push('/')}>
              <span>{i18next.language == 'es' ? 'NUEVA BÚSQUEDA' : 'NEW SEARCH'}</span>
            </button>

            <button
              className="kupos-button2 no-underline-hover"
              style={{ textDecoration: 'none' }}
              onClick={() => this.props.history.push('/pages/contact')}
            >
              <span>{i18next.language == 'es' ? 'CONTÁCTANOS' : 'CONTACT US'}</span>
            </button>
          </div>
        </KuposSuccessFailure>
      </div>
    );
  }
}

export default withTranslation('common')(PageNotFound);



// WEBPACK FOOTER //
// ./src/features/common/PageNotFound.js